import * as React from 'react';
import { Button, Col, Row } from 'reactstrap';
import { IAuthenticatedAppData } from '../../../../AuthenticatedApp/AuthenticatedApp';
import { EventHandlerProvider } from '../../../../Services/EventHandlerService';
import { CustomSpinner } from '../../../../Components';
import { getJson } from '../../../../Services/Util';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import { AddUserEvent, IUsersTableSort, IUsersTableFilter, IUsersTableSearch, IUserData, IUserDataWithActions, UsersTableField, IGetUsersResponse, ITableState, UsersTableColumns, UsersTableDefaultSort, DeleteUserEvent, EditUserEvent, ResetPasswordEvent, TransferSuperUserEvent } from './Types';
import { SearchBar } from './Components';
import { faTrash, faPencilAlt, faLock, faSyncAlt } from '@fortawesome/free-solid-svg-icons';
import { Auth, IAuthenticatedUser } from '../../../../Services/AuthenticationService';
import { ActionButton } from '../../Components';

interface IUsersProps {
    applicationData: IAuthenticatedAppData;
}

interface IUsersState {
    users: IUserDataWithActions[];
    admins: IUserData[];
    totalPages: number;
    errorMessage: string;
    isLoading: boolean;
    totalLicenses: number;
}

export class Users extends React.Component<IUsersProps, IUsersState> {
    tableRef: React.RefObject<any>;
    currentUser: IAuthenticatedUser;
    constructor(props: IUsersProps) {
        super(props);
        //console.log("constructor");
        this.tableRef = React.createRef();
        this.state = {
            users: [] as IUserDataWithActions[],
            totalPages:1,
            errorMessage: "",
            isLoading: false,
            admins: [] as IUserData[],
            totalLicenses: 0
        };
        this.currentUser = Auth.getUser()
    }

    componentDidMount() {
        this.onUpdate();
    }

    onUpdate = () => {
        this.getUserData();
        this.getUsers(100, 0, { field: UsersTableField["Email"], descending: false }, { email: "", displayName: "", userRole: "Administrator" }, { email: "", displayName: "" })
            .then((response: IGetUsersResponse) => { this.setState({ admins: response.item1 }); });
        this.getActiveLicenses().then((response: number) => {this.setState({totalLicenses: response})});
    }

    getUserData = (
        fetchAmount: number = this.tableRef.current.paginationContext.currSizePerPage,
        page: number = this.tableRef.current.paginationContext.currPage,
        order: IUsersTableSort = { field: UsersTableField["Email"], descending: false } as IUsersTableSort,
        filter: IUsersTableFilter = { email: "", displayName: "", userRole: "", defaultLocation: "" } as IUsersTableFilter,
        search: IUsersTableSearch = { email: "", displayName: "" } as IUsersTableSearch
    ): void => {

        let errMsg = "";
        this.getUsers(fetchAmount, page, order, filter, search)
            .then((response: IGetUsersResponse) => {
                var users: IUserDataWithActions[] = [];
                response.item1.forEach((data) => {
                    var localisedRoles = "";
                    data.userRole.split(', ').forEach((value: string, index: number, array:string[]) => {
                        localisedRoles += this.props.applicationData.resources[value];
                        if (index + 1 < array.length) {
                            localisedRoles += ', ';
                        }
                    })
                    users.push({
                        ...data, userRole: localisedRoles, Actions: <div style={{
                            display: 'flex', justifyContent: 'space-evenly'
                        }}>
                            {console.log(this.props.applicationData.userInfo)}
                            {console.log(data.email === this.props.applicationData.userInfo.Email && data.id === this.props.applicationData.userInfo.Id)}
                            <ActionButton
                                Event={ResetPasswordEvent(this.onUpdate, data, this.props.applicationData.resources)}
                                TooltipText={this.props.applicationData.resources.ResetPassword}
                                MultipleIcons={true}
                                Icons={[faLock, faSyncAlt]}
                                colour="primary"
                            >
                            </ActionButton>
                            <ActionButton
                                Event={EditUserEvent(
                                    this.onUpdate, 
                                    data, 
                                    this.props.applicationData.resources, this.props.applicationData.locations, 
                                    this.props.applicationData.userInfo.UserRole.match(/SuperUser/g),
                                    data.email === this.props.applicationData.userInfo.Email && data.id === this.props.applicationData.userInfo.Id)}
                                TooltipText={this.props.applicationData.resources.Edit}
                                Icons={faPencilAlt}
                                colour="primary"
                            >
                            </ActionButton>
                            
                            {(this.currentUser.id !== data.id && (!data.userRole.match(/SuperUser/g) || this.props.applicationData.userInfo.UserRole.match(/SuperUser/g))) &&
                                <ActionButton
                                    Event={DeleteUserEvent(this.onUpdate, data, this.props.applicationData.resources)}
                                    TooltipText={this.props.applicationData.resources.Delete}
                                    Icons={faTrash}
                                    colour="danger"
                                >
                                </ActionButton>
                            }
                        </div>
                    });
                });
                this.setState({
                    users: users,
                    totalPages: response.item2
                });


            }).catch(err => {
                errMsg = err.value || err;
            });
        if (errMsg) {
            console.error(errMsg);
        }
        this.setState({
            errorMessage: errMsg
        });
    }

    getUsers(fetchAmount: number, page: number, order: IUsersTableSort, filter: IUsersTableFilter, search: IUsersTableSearch): Promise<IGetUsersResponse> {
        this.setState({isLoading:true})
        return getJson(`/users/GetUsers?pageSize=${fetchAmount}&pageIndex=${page}&order=${UsersTableField[order.field]}&descending=${order.descending}&filter=${encodeURIComponent(JSON.stringify(filter))}&search=${encodeURIComponent(JSON.stringify(search))}`,
            {
                method: "get",
                headers: {
                    "Accept": "application/json, application/xml, text/plain, text/html, *.*",
                    "Content-Type": "application/json;"
                }
            }).then(response => {
                this.setState({isLoading:false})
                return response as IGetUsersResponse;
            }
        );
    }

    getActiveLicenses =() => {
        return getJson(`/users/GetLicenseCount`, {
            method: "get",
            headers: {
                "Accept": "application/json, application/xml, text/plain, text/html, *.*",
                "Content-Type": "application/json;"
            }
        }).then(response => {
            return response as number;
        });
    }

    getOrder = (newState: ITableState): IUsersTableSort => {
        var order: IUsersTableSort = {} as IUsersTableSort;
        order.descending = newState.sortOrder === "desc";
        if (newState.sortField === "displayName") {
            order.field = UsersTableField.DisplayName;
        } else if (newState.sortField === "email") {
            order.field = UsersTableField.Email;
        } else if (newState.sortField === "userRole") {
            order.field = UsersTableField.UserRole;
        } else if (newState.sortField === "defaultLocation") {
            order.field = UsersTableField.DefaultLocation;
        }
        return order
    }

    onTableChange = (type: string, newState: ITableState) => {

        this.setState({
            users: []
        });

        switch (type) {
            case "filter":
                break;
            case "pagination":
                this.getUserData(newState.sizePerPage, newState.page, this.getOrder(newState), undefined, undefined)
                break;
            case "sort":
                this.getUserData(newState.sizePerPage, newState.page, this.getOrder(newState), undefined, undefined)
                break;
            case "search":
                this.getUserData(newState.sizePerPage, newState.page, this.getOrder(newState), undefined, { email: newState.searchText, displayName: newState.searchText } as IUsersTableSearch);
                break;
            case "cellEdit":
                break;
            default:
                console.warn(`Unknown table change event: ${type}`);
                //console.log(newState);
                break;
        }
    }

    render() {
        return (
            <div className="my-1">
                <ToolkitProvider
                    keyField="id"
                    data={this.state.users}
                    columns={UsersTableColumns(this.props.applicationData.resources)}
                    search
                >
                    {
                        (props: any) => (
                            <div>
                                <div className="my-2">
                                    <Row>
                                        <Col sm="auto">
                                            <Row className="mx-auto">
                                                <Col sm="auto">
                                                    <h2>{this.props.applicationData.resources.Users}</h2>
                                                </Col>
                                                <Col sm="auto" className="fv-c">
                                                    <SearchBar {...props.searchProps} resources={this.props.applicationData.resources}/>
                                                </Col>
                                                <Col>
                                                    {this.props.applicationData.resources.TotalLicenses}{this.state.totalLicenses}
                                                </Col>
                                                <Col>
                                                    {this.props.applicationData.resources.RemainingLicenses}{this.state.totalLicenses - this.state.users.filter(user => !user.userRole.includes('Super User')).length}
                                                </Col>
                                                <Col />
                                            </Row>
                                        </Col>
                                        <Col />
                                        <Col sm="auto" className="fv-c">
                                            {this.props.applicationData.userInfo.UserRole.match(/SuperUser/g) && <Button className="users-add-btn ml-3" color="primary" onClick={() => {
                                                EventHandlerProvider.GetInstance().AddEvent(TransferSuperUserEvent(this.onUpdate, this.state.admins, this.props.applicationData.resources)
                                                );
                                            }} > {this.props.applicationData.resources.TransferSuperUser} </Button>}
                                            <Button className="users-add-btn ml-3" color="primary" onClick={() => {
                                                EventHandlerProvider.GetInstance().AddEvent(AddUserEvent(this.onUpdate, this.props.applicationData.locations, this.props.applicationData.resources, this.props.applicationData.userInfo.UserRole.match(/SuperUser/g))
                                                );
                                            }} > {this.props.applicationData.resources.Registration_AddUserHeading} </Button>
                                        </Col>
                                    </Row>
                                </div>
                                <BootstrapTable {...props.baseProps}
                                    bootstrap4
                                    condensed
                                    hover={this.state.users.length > 0}
                                    noDataIndication={() => { return this.state.isLoading ? <CustomSpinner /> : <div>{this.props.applicationData.resources.NoData}</div>; }}
                                    remote={{
                                        filter: false,
                                        pagination: true,
                                        sort: true,
                                        cellEdit: false
                                    }}
                                    ref={this.tableRef}
                                    onTableChange={this.onTableChange}
                                    bordered={false}
                                    keyField="email"
                                    defaultSorted={UsersTableDefaultSort}
                                    pagination={paginationFactory({ totalSize: this.state.totalPages })}
                                />
                                <div>
                                    {this.props.applicationData.resources.TotalUsers}{this.state.users.length}
                                </div>
                            </div>
                        )
                    }
                </ToolkitProvider>
            </div>
        );
    }
}